import { useEffect } from 'react';

const useRemoveVerifyParam = () => {
  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.has('verify')) {
      url.searchParams.delete('verify');
      window.history.replaceState(null, '', url.toString());
    }
  }, []);
};

export default useRemoveVerifyParam;
